"use client";
import React from "react";
import { SanityDocument } from "@sanity/client";
import SearchableFAQAccordion from "./searchable-faq-accordion";
import SectionHeader from "@components/common/section-header";

interface FaqsProps {
  faqs: SanityDocument[];
}

function Faqs({ faqs }: Readonly<FaqsProps>) {
  return (
    <section className="flex min-h-screen flex-col p-5 py-8 font-Satoshi-Medium text-base md:px-10 md:text-lg lg:py-20">
      <SectionHeader
        highlightedTitle="Get Clarity,"
        title="Make Informed Decisions!"
        bodyText="If you're new to Rake Engineering Consultancy or need expert consultation in the
          construction industry, we're here to help. This guide will
          introduce you to our platform and how it can support your business."
      />

      <SearchableFAQAccordion faqs={faqs} />
    </section>
  );
}

export default Faqs;
